// extracted by mini-css-extract-plugin
module.exports = {"header":"DeliverableList_header__2cDmk","card":"DeliverableList_card__28a4j","content":"DeliverableList_content__3yh9v","table":"DeliverableList_table__2RhHO"};